import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const ProtectedRoute = ({ children }) => {
  // Ajusta "tipoUsuarioId" según el nombre de tu cookie real
  const tipoUsuarioId = cookies.get("tipoUsuarioId");

  if (!tipoUsuarioId) {
    // 👉 Redirección inmediata al login
    return <Navigate to="/auth/login" replace />;
  }

  // Si la cookie existe, renderiza el contenido
  return children;
};

export default ProtectedRoute;
